import { ElectricalLayoutType } from "building-types/electrical/electricalLayoutTypesEnum";

export const ElectricalLayoutTypeName: { [key in ElectricalLayoutType]?: string } = {
  [ElectricalLayoutType.SINGLE_LIGHT]: "Single Load",
  [ElectricalLayoutType.GARAGE_LIGHTS]: "Garage Lights",
  [ElectricalLayoutType.FOUR_LIGHTS]: "Four Loads",
  [ElectricalLayoutType.AT_DOOR_BY_TYPE]: "At Door By Type",
  [ElectricalLayoutType.AT_BACK_OF_PROP]: "At Back of Prop",
  [ElectricalLayoutType.STANDARD_OUTLETS]: "Edge Loads",
  [ElectricalLayoutType.LINEAR_ARRAY]: "Linear Array",
  [ElectricalLayoutType.RECTANGULAR_ARRAY]: "Rectangular Array",
};
export const ElectricalLayoutTypesForUi: { [key in ElectricalLayoutType]?: true } = {
  [ElectricalLayoutType.SINGLE_LIGHT]: true,
  [ElectricalLayoutType.GARAGE_LIGHTS]: true,
  [ElectricalLayoutType.FOUR_LIGHTS]: true,
  [ElectricalLayoutType.AT_DOOR_BY_TYPE]: true,
  [ElectricalLayoutType.AT_BACK_OF_PROP]: true,
  [ElectricalLayoutType.STANDARD_OUTLETS]: true,
  [ElectricalLayoutType.LINEAR_ARRAY]: true,
  [ElectricalLayoutType.RECTANGULAR_ARRAY]: true,
};
export const ElectricalLayoutTypesAbbrevations: { [key in ElectricalLayoutType]?: string } = {
  [ElectricalLayoutType.SINGLE_LIGHT]: "single ld",
  [ElectricalLayoutType.GARAGE_LIGHTS]: "garage lts",
  [ElectricalLayoutType.FOUR_LIGHTS]: "4 lds",
  [ElectricalLayoutType.AT_DOOR_BY_TYPE]: "dr lts",
  [ElectricalLayoutType.AT_BACK_OF_PROP]: "prop back",
  [ElectricalLayoutType.STANDARD_OUTLETS]: "edge lds",
  [ElectricalLayoutType.LINEAR_ARRAY]: "linear arr",
  [ElectricalLayoutType.RECTANGULAR_ARRAY]: "rect arr",
};
